import { useTranslation } from "next-i18next";

export default function LargePaginationButtons(props: any) {
  const { currentPage, products, onSelectPage } = props;
  const { t } = useTranslation("product");

  if (products.products && products.products.length > 0) {
    const totalPages = Math.ceil(products.totalHits / 12);

    return (
      <div className="pagination-buttons-container">

        <button
          type="button"
          className="btn btn-primary btn-action btn-prev-page"
          onClick={() => onSelectPage(currentPage - 1)}
          disabled={currentPage === 1}
        >

          <span className="fa fa-long-arrow-left m-r-5" />
          {t("Previous Page")}
        </button>

        <button
          type="button"
          className="btn btn-primary btn-action btn-next-page"
          onClick={() => onSelectPage(currentPage + 1)}
          disabled={currentPage === totalPages}
        >
          {t("Next Page")}

          <span className="fa fa-arrow-right m-l-10" />
        </button>

        <div className="clearfix" />
      </div>
    );
  }

  return <span />;
}
